import React, { useEffect, useState } from 'react';
import cls from 'classnames';
import Card from './components/Card';
import { useInView } from '@byted/hooks';
import { logger } from '@/pages/business/utils/lib';
import styles from './index.module.scss';

const Roles = ({
  className,
  name = '',
  data
}) => {
  const [ref, inView] = useInView();
  const [reported, setReported] = useState(false);
  useEffect(() => {
    if (!reported && inView) {
      logger.sendPageShow({
        section_name: name
      });
      setReported(true);
    }
  }, [inView, reported]);
  return /*#__PURE__*/React.createElement("section", {
    ref: ref
  }, /*#__PURE__*/React.createElement("ul", {
    "data-scroll": true,
    className: cls(styles.container, className)
  }, data.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, item))))));
};

export default Roles;